import { IVisits, IVisitsListItem, VisitsResponseType } from "./visit.types";

export default class Visits implements IVisits {
    total: number;
    data: IVisitsListItem[] = [];
    constructor(data: VisitsResponseType) {
        this.total = data.total;
        for (let i = 0; i < data.data.length; i++) {
            this.data.push(data.data[i]);
        }
    }

}